(() => {
  let temporarilyOpened = [];
  const openAnswers = () => {
    temporarilyOpened = [];
    document.querySelectorAll('.hk188-hero-wrap ~ .hk188-faq, .article-template__content details.hk188-faq').forEach((element) => {
      if (!element.open) {
        temporarilyOpened.push(element);
        element.open = true;
      }
    });
  };
  const restoreAnswers = () => {
    temporarilyOpened.forEach((element) => { if (element.isConnected) element.open = false; });
    temporarilyOpened = [];
  };
  window.addEventListener('beforeprint', openAnswers);
  window.addEventListener('afterprint', restoreAnswers);
})();